
import { Solution } from "@/types/solutions";
import sustainableConstruction from "@/assets/solutions/sustainable-construction.jpg";
import workplaceDesign from "@/assets/solutions/workplace-design.jpg";
import historicPreservation from "@/assets/solutions/historic-preservation.jpg";
import procurement from "@/assets/solutions/procurement.jpg";
import assetManagement from "@/assets/solutions/asset-management.jpg";
import k12Education from "@/assets/solutions/k12-education.jpg";
import higherEducation from "@/assets/solutions/higher-education.jpg";
import weatherServices from "@/assets/solutions/weather-services.jpg";
import coastalManagement from "@/assets/solutions/coastal-management.jpg";
import fleetManagement from "@/assets/solutions/fleet-management.jpg";
import technology from "@/assets/solutions/technology.jpg";
import assessment from "@/assets/solutions/assessment.jpg";
import specialEducation from "@/assets/solutions/special-education.jpg";
import oceanScience from "@/assets/solutions/ocean-science.jpg";
import climateScience from "@/assets/solutions/climate-science.jpg";

// Sample data for the solutions
export const solutionsData: Solution[] = [
  // Julia De Rosi GSA solutions from the image
  {
    id: "gsa-j1",
    title: "Federal Building Sustainable Construction Framework",
    agency: "GSA",
    creator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Sustainability",
    basePrice: 35000,
    price: 35000,
    description: "Comprehensive framework for implementing sustainable construction practices in federal buildings.",
    capturedDate: "2024-03-20",
    image: sustainableConstruction
  },
  {
    id: "gsa-j2",
    title: "GSA Public Building Service Modern Workplace Strategy",
    agency: "GSA",
    creator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Workplace Design",
    basePrice: 25000,
    price: 25000,
    description: "Strategic approach to designing and implementing modern workplace environments for federal agencies.",
    capturedDate: "2024-02-15",
    image: workplaceDesign
  },
  {
    id: "gsa-j3",
    title: "Federal Historic Property Adaptive Reuse Model",
    agency: "GSA",
    creator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Historic Preservation",
    basePrice: 30000,
    price: 30000,
    description: "Model for adapting and repurposing historic federal properties while preserving their cultural significance.",
    capturedDate: "2024-01-25",
    image: historicPreservation
  },
  // Original sample data
  {
    id: "gsa-001",
    title: "Federal Acquisition Streamlining Framework",
    agency: "GSA",
    creator: "Karen Thompson",
    commercialType: "Sale",
    category: "Procurement",
    basePrice: 2500,
    price: 2500,
    description: "Specialized knowledge base on navigating federal procurement regulations and optimizing acquisition processes.",
    image: procurement
  },
  {
    id: "gsa-002",
    title: "Government Property Management System",
    agency: "GSA",
    creator: "Trey Fleming",
    commercialType: "Lease",
    category: "Asset Management",
    basePrice: 18000,
    price: 1800,
    description: "Comprehensive system for tracking and managing government property assets across agencies.",
    image: assetManagement
  },
  {
    id: "gsa-003",
    title: "Federal Building Sustainability Guide",
    agency: "GSA",
    creator: "Morgan Chen",
    commercialType: "Collaborate",
    category: "Sustainability",
    basePrice: 4750,
    price: 950,
    description: "Knowledge base for implementing green building practices in federal facilities.",
    image: sustainableConstruction
  },
  {
    id: "ed-001",
    title: "Title I Program Implementation Framework",
    agency: "Education",
    creator: "Mike Mosher",
    commercialType: "Sale",
    category: "K-12 Education",
    basePrice: 3200,
    price: 3200,
    description: "Expert guidance on implementing and managing Title I programs for disadvantaged students.",
    image: k12Education
  },
  {
    id: "ed-002",
    title: "Federal Student Aid Processing System",
    agency: "Education",
    creator: "Sarah Johnson",
    commercialType: "Lease",
    category: "Higher Education",
    basePrice: 45000,
    price: 4500,
    description: "Specialized knowledge on federal student aid processing and compliance requirements.",
    image: higherEducation
  },
  {
    id: "noaa-001",
    title: "Advanced Weather Prediction Models",
    agency: "NOAA",
    creator: "Jim Collins",
    commercialType: "Stake",
    category: "Weather Services",
    basePrice: 15600,
    price: 7800,
    description: "Sophisticated weather prediction models developed by NOAA scientists.",
    image: weatherServices
  },
  {
    id: "noaa-002",
    title: "Coastal Erosion Mitigation Framework",
    agency: "NOAA",
    creator: "Rachel Waters",
    commercialType: "Collaborate",
    category: "Coastal Management",
    basePrice: 14500,
    price: 2900,
    description: "Expert knowledge base on managing and mitigating coastal erosion issues.",
    image: coastalManagement
  },
  // Adding more items to demonstrate the concept
  // GSA items
  {
    id: "gsa-004",
    title: "Federal Fleet Management System",
    agency: "GSA",
    creator: "Karen Thompson",
    commercialType: "Sale",
    category: "Fleet Management",
    basePrice: 3200,
    price: 3200,
    description: "Comprehensive system for federal vehicle fleet management and optimization.",
    image: fleetManagement
  },
  {
    id: "gsa-005",
    title: "Government Technology Procurement Guide",
    agency: "GSA",
    creator: "Trey Fleming",
    commercialType: "Lease",
    category: "Technology",
    basePrice: 19500,
    price: 1950,
    description: "Expert guidance on procuring and implementing technology solutions in government contexts.",
    image: technology
  },
  // Education items
  {
    id: "ed-003",
    title: "Educational Assessment Framework",
    agency: "Education",
    creator: "Mike Mosher",
    commercialType: "Sale",
    category: "Assessment",
    basePrice: 2700,
    price: 2700,
    description: "Specialized knowledge base for developing and implementing educational assessments.",
    image: assessment
  },
  {
    id: "ed-004",
    title: "Special Education Compliance System",
    agency: "Education",
    creator: "Sarah Johnson",
    commercialType: "Collaborate",
    category: "Special Education",
    basePrice: 19000,
    price: 3800,
    description: "Comprehensive knowledge base on special education regulations and compliance.",
    image: specialEducation
  },
  // NOAA items
  {
    id: "noaa-003",
    title: "Marine Ecosystem Monitoring Framework",
    agency: "NOAA",
    creator: "Jim Collins",
    commercialType: "Stake",
    category: "Ocean Science",
    basePrice: 11200,
    price: 5600,
    description: "Advanced system for monitoring and analyzing marine ecosystem health.",
    image: oceanScience
  },
  {
    id: "noaa-004",
    title: "Climate Data Analysis Tools",
    agency: "NOAA",
    creator: "Rachel Waters",
    commercialType: "Sale",
    category: "Climate Science",
    basePrice: 4200,
    price: 4200,
    description: "Specialized tools for analyzing and interpreting climate data sets.",
    image: climateScience
  }
];
